import React, { useContext } from "react";
import { css } from "emotion";
import GenericButton from "../GenericButton";
import workspaces from "../../services/api/workspaces";
import { GlobalContext } from "../../context/GlobalState";
import { withRouter } from "react-router-dom";

const InviteListItem = ({ history, invite }) => {
  const {
    setCurrentWorkspace,
    setWorkspaces,
    updateUser,
    userData,
    currentWorkspace,
  } = useContext(GlobalContext);
  const handleClick = async () => {
    try {
      const { data } = await workspaces.acceptInvite({
        workspaceId: invite.workspaceId,
      });
      const { workspacesArray, userWorkspaces } = data;

      // set the workspaces array
      setWorkspaces(workspacesArray);

      // delete the invite from the user's invites array
      const filteredInvites = userData.invites.filter(
        (inviteItem) => inviteItem.workspaceId !== invite.workspaceId
      );

      // decide if the user is admin
      const isAdmin = invite.role === "admin";

      // update the user
      updateUser({ invites: filteredInvites, roles: userWorkspaces, isAdmin });

      if (!currentWorkspace) {
        // set current workspace
        const { data } = await workspaces.find({
          id: invite.workspaceId,
        });
        const workspaceToSet = data;
        // console.log(workspaceToSet);
        setCurrentWorkspace(workspaceToSet);
      }

      //navigate to home
      history.push("/home");
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div className={container}>
      <h3>{invite.name}</h3>
      <GenericButton
        text="Accept"
        style="accept-btn"
        handleClick={handleClick}
      />
    </div>
  );
};

export default withRouter(InviteListItem);

const container = css`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .accept-btn {
    width: 20%;
    min-width: 100px;
  }
`;
